exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn._1lHcsjdTUeD_rpGpQDAKF4{margin-left:5px}", ""]);

// exports
exports.locals = {
	"button": "_1lHcsjdTUeD_rpGpQDAKF4"
};